import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaBlock, CtaGuaranteeRow } from './CtaBlock';
import { HERO_IMAGE, stats } from '../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-navy-900" data-id="element-202" data-mp="9ka5gxomiqwe">
      <div className="pointer-events-none absolute inset-0 opacity-[0.35]" style={{
      backgroundImage: 'radial-gradient(circle at 50% 0%, rgba(201,162,39,0.18), transparent 55%)'
    }} aria-hidden="true" data-id="element-203" data-mp="9ipc3be1pe04" />

      <div className="relative mx-auto w-full max-w-6xl px-4 pb-12 pt-8 sm:px-6 sm:pt-10 lg:pb-16" data-id="element-204" data-mp="xbfi73z9p32h">
        <div className="flex items-center justify-center gap-2 pb-6" data-id="element-205" data-mp="s9zzhikkb8n9">
          <ShieldCheckIcon className="h-5 w-5 text-gold-400" aria-hidden="true" data-id="element-206" data-mp="ncq0pcba9kmr" />
          <span className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-white sm:text-xs" data-id="element-207" data-mp="3d1im5e7m7kpj">
            Sistema Maestro della TRT™
          </span>
        </div>

        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_1fr] lg:gap-12" data-id="element-208" data-mp="384js0vnybdrc">
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-209" data-mp="3j9ai9gc8yw6q">
            <p className="mb-4 rounded-full border border-gold-500/40 bg-gold-500/10 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.16em] text-gold-300 sm:text-[11px]" data-id="element-210" data-mp="3o73qeex4209n">
              Per professionisti sanitari
            </p>

            <h1 className="text-balance text-[30px] font-black uppercase leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-[54px]" data-id="element-211" data-mp="30i15my76jrax">
              Prendi decisioni sulla TRT in{' '}
              <span className="text-gold-400" data-id="element-212" data-mp="2qjv8sv08dbcx">meno di 5 minuti</span>
            </h1>

            <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-white/75 sm:text-lg" data-id="element-213" data-mp="2qi0l58xkr555">
              Algoritmi clinici passo dopo passo per sapere se iniziare,
              modificare, rimandare o interrompere una TRT — senza consultare
              numerose linee guida durante ogni visita.
            </p>

            <p className="mt-4 text-[13px] font-extrabold uppercase tracking-[0.12em] text-gold-300 sm:text-sm" data-id="element-214" data-mp="s1rpyhl8dur4">
              Domina la TRT senza improvvisare
            </p>

            <div className="mt-8 w-full lg:max-w-xl" data-id="element-215" data-mp="n98fvulr5hr2">
              <CtaBlock id="hero-cta" label="Accedi al Sistema Maestro della TRT™" note="Accesso digitale immediato · 19 EUR" tone="dark" showScarcity data-id="element-216" data-mp="id9t2bg2o7sr" />
              <div className="mt-4" data-id="element-217" data-mp="1ayjilhmnxm7u">
                <CtaGuaranteeRow tone="dark" data-id="element-218" data-mp="161jaz2a60bem" />
              </div>
            </div>
          </div>

          <div className="order-first lg:order-last" data-id="element-219" data-mp="111ycesywq52f">
            <img src={HERO_IMAGE} alt="Sistema Maestro della TRT™ — sei volumi clinici disponibili su computer, tablet e smartphone" className="mx-auto w-full max-w-lg drop-shadow-[0_25px_45px_rgba(0,0,0,0.45)]" width={1080} height={1080} data-id="element-220" data-mp="114svag29vhtq" />
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/10 bg-navy-950/60" data-id="element-221" data-mp="1xam6ou2m9x0i">
        <ul className="mx-auto grid w-full max-w-5xl grid-cols-2 gap-px px-4 py-6 sm:px-6 lg:grid-cols-4" data-id="element-222" data-mp="21aejxk2ygrc7">
          {stats.map(stat => <li key={stat.label} className="px-2 py-3 text-center" data-id="element-223" data-mp="268of3uoojrxt">
              <p className="text-3xl font-black leading-none text-gold-400 sm:text-4xl" data-id="element-224" data-mp="2b1rbeakudfhp">
                {stat.value}
              </p>
              <p className="mt-2 text-[10px] font-bold uppercase leading-tight tracking-[0.14em] text-white/60 sm:text-[11px]" data-id="element-225" data-mp="2fzj436tb95my">
                {stat.label}
              </p>
            </li>)}
        </ul>
      </div>
    </header>;
}